import * as Tooltip from '@radix-ui/react-tooltip';
import styles from './index.module.scss';

const BustlyTooltip = ({
    children,
    content,
    side = 'top',
}: {
    children: React.ReactNode;
    content?: string;
    side?: 'top' | 'bottom' | 'left' | 'right';    
}) => {
    if(!content) {
        return children;
    }
    return (
        <Tooltip.Provider delayDuration={200}>
            <Tooltip.Root>
                <Tooltip.Trigger asChild>
                    {children}
                </Tooltip.Trigger>
                <Tooltip.Portal>
                    <Tooltip.Content 
                        className={styles['tooltip-text']}
                        side={side}
                        align="center"
                        sideOffset={8}
                    >
                        {content}
                        <Tooltip.Arrow className={styles['tooltip-arrow']} />
                    </Tooltip.Content>
                </Tooltip.Portal>
            </Tooltip.Root>
        </Tooltip.Provider>
    );
}
export default BustlyTooltip;